<template>
    <a-card>
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                <a-icon type="clock-circle" />
            </a-col>
            <a-col :flex="3" justify="center">
                <p>Waiting Time</p>
            </a-col> 
        </a-row>

        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="3" justify="center">
                <a-slider :marks="marks" 
                        v-model="currentWaitingTime" 
                        :min="5" 
                        :max="60" 
                        :step="5"
                        @afterChange="handleChanged"
                        @change="handleChange"
                />   
            </a-col> 
        </a-row>
    </a-card>
</template>

<script>
export default {
    props : {
        waitingTime : Number,
        min : Number,
        max : Number 
    },
    

    data() {
        return {
            marks : {
                5 : '5',
                15 : '15',
                30 : '30',
                45 : '45',
                60 : '60'
            },
            currentWaitingTime : this.waitingTime

        }
    },

    methods : {
        handleChanged() {
            this.$emit('changed', this.currentWaitingTime );
            //console.log('Changed ' + this.waitingTime + ' - ' + this.currentWaitingTime)
        },
        handleChange() {
            //console.log('Change ' + this.waitingTime + ' - ' + this.currentWaitingTime)
        }
    },

    watch : {
        waitingTime : {
            handler(newValue) {
                this.currentWaitingTime = newValue;
            },
            flush : 'post'
        }
    }
}
</script>

<style scoped>
.icons-list >>> .anticon {
  margin-right: 6px;
  font-size: 24px;
}
</style>
